import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/pagination"; // Import Swiper pagination styles
import "swiper/css/navigation"; // Import Swiper navigation styles
import SwiperCore from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { motion } from "framer-motion";

// Install Swiper modules
SwiperCore.use([Pagination, Navigation]);

function Testimonial({ logoSrc, sentence, title }) {
  return (
    <article className="flex flex-col justify-center pb-4 w-full bg-white rounded-xl shadow-xl max-md:mt-8">
      <div className="flex justify-center items-center px-16 py-3.5 bg-light-indigo border-dark-indigo border-b-[3px] rounded-t-xl shadow-sm max-md:px-5">
        <img
          alt="Client Logo"
          src={logoSrc}
          className="max-w-full aspect-[7.14] w-[152px]"
        />
      </div>
      <div>
        <p className="pt-2 px-4 text-[21px] font-medium light-testimonial-text">{title}</p>
      </div>
      <blockquote className="mx-4 mt-2 text-lg leading-5 light-title max-md:mx-2.5">
        <p className="dark-testimonial-text">
          <span className="text-5xl lowercase">“</span>
          {sentence}
        </p>
      </blockquote>
    </article>
  );
}

const testimonials = [
  {
    logoSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/5d0f3d28d63b0ed377625cba0fa9c6adc22cb0bedce7b3936e65aa2e9fc585e1?apiKey=3756b57bedc84c2cbd55485bb12ec63c&",
    title: "Global Strategy Consultancy Partner",
    sentence:
      "EXPERTEFY has been a game-changer for our firm. Their swift access to industry expertise has saved us time and resources, allowing us to serve our clients more effectively.",
  },
  {
    logoSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/59c8aaffcf471959a123ebf4b4a59039cf8814d579112e5c72677ebbe0ca1c40?apiKey=3756b57bedc84c2cbd55485bb12ec63c&",
    title: "US Life Science Consultancy Principal",
    sentence:
      "We've been impressed with EXPERTEFY'S affordability and reliability. Their experts are available around the clock, ensuring we get the insights we need when we need them. EXPERTEFY has become an integral part of our process. Their commitment to confidentiality gives us peace of mind when dealing with sensitive projects.",
  },
  {
    logoSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/f88115be6c6c5e6a9c98cdaa1f28b6e5e71fab787c494fbc0dcced07a53295ba?apiKey=3756b57bedc84c2cbd55485bb12ec63c&",
    title: "UK Strategy Consultancy Managing Director",
    sentence:
      "Their flexibility and responsiveness have allowed us to adapt to our clients' evolving needs quickly. Working with them has been a seamless experience.",
  },
  {
    logoSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/f88115be6c6c5e6a9c98cdaa1f28b6e5e71fab787c494fbc0dcced07a53295ba?apiKey=3756b57bedc84c2cbd55485bb12ec63c&",
    title: "Global Consulting Firm Engagement Manager",
    sentence:
      "EXPERTEFY'S personalized approach sets them apart. They took the time to understand our unique needs in the renewable energy sector and connected us with experts who provided invaluable insights.",
  },
];

const ClientsTestimonials = () => {
  return (
    <motion.section
      initial={{ opacity: 0, scale: 0.5  }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
      viewport={{ once: true }}
      className="flex flex-col items-center px-5 mt-15 w-full max-md:mt-10 max-md:max-w-full">
      <div className="text-base leading-4 text-center light-title">
        <span className="text-lg text-color">TESTIMONIALS</span>
        <br />
        <span className="text-3xl sm:text-5xl font-medium light-title">
          What Our Clients Say
        </span>
        <br />
      </div>
      <Swiper
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        speed={1000} // Adjust speed of transition for a smoother loop
        spaceBetween={30}
        navigation={true}
        pagination={{ clickable: true }}
        loop={true}
        modules={[Autoplay, Navigation]}
        className="mt-6 w-full max-w-[1120px] max-md:max-w-full"
        breakpoints={{
          // when window width is <= 768px (tablet)
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          // when window width is <= 1024px (desktop)
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <Testimonial {...testimonial} />
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.section>
  );
};

export default ClientsTestimonials;
